import { IconQuestionHeader } from "@/assets/icons/IconQuestionHeader";
import { background, text } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";
import { openNewTab } from "@/utils/url";
import { Tooltip as MuiTooltip, Stack, TooltipProps, Typography, styled, tooltipClasses } from "@mui/material";
import { FC } from "react";

export type THelpHeaderTooltipProps = {};

export const HelpHeaderTooltip: FC<THelpHeaderTooltipProps> = ({}) => {
  return (
    <StyledTooltip placement="bottom" arrow title={<Typography variant="cap12">ヘルプ</Typography>}>
      <Stack
        sx={{ cursor: "pointer", height: "fit-content" }}
        onClick={() => {
          openNewTab("https://support.iro-hana.com/irohana-rso-guide", "irohana-rso-guide");
        }}
      >
        <IconQuestionHeader color={background.white} width={24} height={24} />
      </Stack>
    </StyledTooltip>
  );
};

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => <MuiTooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    backgroundColor: background.white,
    color: text.primary,
    padding: spacing.sm,
    borderRadius: rounded.sm,
    boxShadow: "0px 2px 8px 0px #00000040",
  },
  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
    marginTop: "4px",
    marginLeft: "4px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: background.white,
  },
}));
